import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProductGrid from '../components/ProductGrid'; // Reusamos tu grilla de productos
import './SearchResultsPage.css'; // Creamos un CSS para esta página

const SearchResultsPage = () => {
  const [searchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Leemos el parámetro 'q' de la URL (ej: /search?q=rtx)
  const query = searchParams.get('q'); 

  useEffect(() => {
    // No buscar si no hay nada en el query
    if (!query) {
      setProducts([]);
      return;
    }

    const fetchResults = async () => {
      setIsLoading(true);
      setError('');
      try {
        // Usamos la URL que nos pasaste, agregando el query
        const response = await fetch(`https://tech-market-ba-back.vercel.app/products/search/${query}`);
        
        if (!response.ok) {
          throw new Error('No se encontraron productos para tu búsqueda.');
        }
        
        const data = await response.json();
        setProducts(data);

      } catch (err) {
        setError(err.message);
        setProducts([]); // Limpiamos resultados en caso de error
      } finally {
        setIsLoading(false);
      }
    };

    fetchResults();
  }, [query]); // Volvemos a buscar CADA VEZ que el query en la URL cambie

  return (
    <div className="search-results-container">
      {isLoading ? (
        <p>Buscando productos...</p>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : (
        <>
          <h1>Resultados para: "{query}"</h1>
          {products.length === 0 ? (
            <p>No se encontraron productos que coincidan con tu búsqueda.</p>
          ) : (
            <ProductGrid products={products} />
          )}
        </>
      )}
    </div>
  );
};

export default SearchResultsPage;